import { render, staticRenderFns } from "./MusicBox.vue?vue&type=template&id=3072ba89&scoped=true&"
import script from "./MusicBox.vue?vue&type=script&lang=js&"
export * from "./MusicBox.vue?vue&type=script&lang=js&"
import style0 from "./MusicBox.vue?vue&type=style&index=0&id=3072ba89&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3072ba89",
  null
  
)

export default component.exports